var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel1Aroha1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.78,
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.2,320.54a3.57,3.57,0,0,1,0-.8,8.53,8.53,0,0,0,1.48-5.84,2.6,2.6,0,0,0-.37-1.18,1.12,1.12,0,0,0-1-.54c-.84.15-.86.86-1,1.55l.11.73a6.22,6.22,0,0,0-3.64-4.09,3.66,3.66,0,0,0-4.73,2.51c-.71,5.23,2.2,5.76,3.36,10.91a68,68,0,0,0,15.19,29.14l6.53-2.35A42.72,42.72,0,0,1,144.2,320.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel1Aroha1A);
export default __webpack_public_path__ + "static/media/Idea_Panel_1_Aroha_1a.f4a5acaa972d259dca8bb387d011acda.svg";
export { ForwardRef as ReactComponent };